const popup = {
  header: 'Дарим индивидуальную скидку!',
  subtitle: '–5% по промокоду*',
  conditionFebruary:
    'Промокод действует до 28.02.23. <br/> Скидка не суммируется с другими акциями <br/> и специальными предложениями.',
  promocode: 'shop5',
  conditionMarch:
    'Промокод действует до 31.03.23. <br/> Скидка не суммируется с другими акциями <br/> и специальными предложениями.',
  endDate: new Date(2023, 2, 31, 23, 59, 59),
};

export default popup;
